import { Component } from '@angular/core';

@Component({
  selector: 'app-fourtyYears',
  templateUrl: './fourtyYears.component.html',
  styleUrls: ['./fourtyYears.component.scss'],
})
export class FourtyYearsPageComponent {}
